import React from 'react';
import styles from './shot-map-goal-view.module.scss';
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export const ShotMapGoalViewDetailsCard = (({detail, controller}: BaseProps) => {
  const {terms} = controller;

  return (
    <div className={classNames(styles.card_container)}>
      <bdi className={classNames(styles.card_main_text)}>{detail.value}</bdi>
      <div className={classNames(styles.card_sub_text)}>{terms[detail.aliasName]}</div>
    </div>
  )
});
